import { useEffect, useState } from 'react';
import { api } from '../api';
import { onCommandDone } from '../api/events';

export interface ShellCounters {
  /** Заказы с постоплатой, отгруженные и не оплаченные (home.summary.payment_reminders). */
  paymentReminders: number | null;
}

const REFRESH_MS = 5 * 60 * 1000;
const listeners = new Set<() => void>();
export function refreshShellCounters(): void { listeners.forEach((fn) => fn()); }

/** Единственный счётчик тулбара в MVP — напоминания об оплате. Ошибки глушатся: тулбар не ломает оболочку. */
export function useShellCounters(enabled: boolean): ShellCounters {
  const [state, setState] = useState<ShellCounters>({ paymentReminders: null });
  useEffect(() => {
    if (!enabled) return;
    let alive = true;
    const load = () => {
      api.query<{ payment_reminders?: number }>('home.summary', {})
        .then((r) => { if (alive) setState({ paymentReminders: r.data?.payment_reminders ?? 0 }); })
        .catch(() => undefined);
    };
    load();
    listeners.add(load);
    const off = onCommandDone((op) => { if (/^(orders|payments)\./.test(op)) load(); });
    const timer = window.setInterval(load, REFRESH_MS);
    return () => { alive = false; listeners.delete(load); off(); window.clearInterval(timer); };
  }, [enabled]);
  return state;
}
